import {
  defaultShouldDehydrateQuery,
  QueryClient,
} from "@tanstack/react-query";
import { ONE_MIN_MS } from "@/lib/constants";
import getLogger from "@/lib/logger";

const logger = getLogger("trpc:query-client");

// docs https://tanstack.com/query/latest/docs/reference/QueryClient
export function makeQueryClient() {
  return new QueryClient({
    defaultOptions: {
      queries: {
        // Avoid refetching immediately on the client after SSR hydration
        staleTime: 2 * ONE_MIN_MS,
      },
      dehydrate: {
        // Include pending queries so we can start prefetching in a server
        // component and hydrate the promise into a client component
        shouldDehydrateQuery: (query) =>
          defaultShouldDehydrateQuery(query) ||
          query.state.status === "pending",
        // query-core throws the real error away and dehydrates a bare
        // `Error("redacted")`, so log it here first; `true` keeps the
        // redaction the client already gets.
        shouldRedactErrors: (error) => {
          logger.error(
            error,
            "A query dehydrated as pending later rejected; error redacted for the client",
          );
          return true;
        },
      },
    },
  });
}
